import { useAuthContext } from "../Contexts/AuthProvider";

import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { IconButton } from "@mui/material";

import styles from "./PodcastHeader.module.css";
import { Link } from "react-router-dom";
import UserAvatar from "../UserAvatar";
import NavMenu from "./NavMenu";
import MenuIcon from '@mui/icons-material/Menu';
import ProfileModal from "../Profile/ProfileModalTailwind";
import { useState } from "react";
import GradientLine from "./GradientLine";

const Header = () => {
  const [userModalOpen, setUserModalOpen] = useState(false);

  const { user, hasPrivilege } = useAuthContext();

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const handleAvatarClick = () => {
    if (!user) return;

    setUserModalOpen(true); return;
  }

  const getNavMenuItems = () => {
    let ret = [];

    if (user) {
      ret.push({ path: '/history', label: 'History' });
    }

    return ret;
  }

  return (
    <>
      <GradientLine />
      <div className={styles.header}>
        <img src="/Podpage.png" alt="Logo" className={styles["logo"]} />
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          {user ?
            <IconButton onClick={handleAvatarClick}>
              <UserAvatar user={user} sx={{
                width: { 'xs': '32px', 'md': '32px' },
                height: { 'xs': '32px', 'md': '32px' },
                fontSize: '10pt'
              }} />
            </IconButton>
            :
            null
          }
          <NavMenu iconElement={<MenuIcon />} mobile={isMobile} items={getNavMenuItems()} />
        </div>
      </div>

      <nav className={styles["tabs"]}>
        <Link to="/" className={window.location.pathname === '/' ? styles.active : ''}>My Podcasts</Link>
        {hasPrivilege('teacher') &&
          <Link to="/classes" className={window.location.pathname === '/classes' ? styles.active : ''}>My Class</Link>
        }
        <Link to="/favourites" className={window.location.pathname === '/favourites' ? styles.active : ''}>My Favourites</Link>
        <Link to="/playlists" className={window.location.pathname === '/playlists' ? styles.active : ''}>Playlists</Link>
      </nav>


      {user && userModalOpen &&
        <div style={{ color: 'black' }}>
          <ProfileModal userId={user.id} onClose={() => setUserModalOpen(false)} />
        </div>
      }
    </>
  )
}

export default Header;
